export const ORIGINALEVIDENCE = 'originalEvidence';
export const LITIGATIONLEGALDOC = 'litigationLegalDoc';
export const EXECUTIONLEGALDOC = 'executionLegalDoc';
export const LITIPRSVLEGALDOC = 'litiPrsvLegalDoc';
export const MEDIATIONLEGALDOC = 'mediationLegalDoc';

export const DOC_CHECK_STATUS = {
  0: "待确认",
  1: "确认中",
  2: "确认无误",
  3: "有异议",
}

export const ONLINE_MEDATION_TIME = {
  1: "10:00:00",
  2: "14:00:00",
  3: "16:00:00",
}

export const ONLINE_MEDATION_STATUS = {
  1: "未开始",
  2: "线上调解中",
  3: "已结束",
}